import { Component, OnInit } from '@angular/core';
import {BusService} from "../../services/bus.service";
import {CollectionService} from "../../services/collection.service";
import {WatchService} from "../../services/watch.service";
import {forEach} from "@angular/router/src/utils/collection";
import {paramsHelper} from "../../helpers/params-helper";
import {IDocument} from "../../interfaces/document.definition";
import {DOCUMENT_TYPES, SPECIAL_RES_STRATEGIES, VALUE_TYPE} from "../../enums/enums";
import {UI_TEXTS} from "../../enums/e-texts";
import {SEARCH_PROP_TYPES} from "../../enums/e-search";
import {GO_CATEGORIES} from "../../enums/e-game-objects";
import {localeUtils} from "../../helpers/locale-utils";

@Component({
  selector: 'app-game-event-map-page',
  templateUrl: './game-event-map-page.component.html',
  styles: []
})
export class GameEventMapPageComponent implements OnInit {
	
  VAL_TYPES = VALUE_TYPE;
  UI_TEXTS = UI_TEXTS;
  
  pageParams = paramsHelper.page()
    .setTitle("Карта ивентов");
	
  document:IDocument;
  resourcesList:IDocument[];

  collectionParams = paramsHelper.collection()
	.setObjectType(DOCUMENT_TYPES.GAME_EVENT_MAP)
    .setDefaultListLabels()
	.setItemLabelQuery('codeName');
	
  constructor(private busService:BusService,
              private collectionService:CollectionService,
              private watchService:WatchService) { }

  ngOnInit() {
	  this.busService.onDocumentUpdated
        .subscribe(e => this.updateDocument(e.document as IDocument));
	  this.loadResourcesList();
  }
  
  private  loadResourcesList(){
    const search = paramsHelper
      .search()
      .addParam("category", SEARCH_PROP_TYPES.ENUM_MULTI, [GO_CATEGORIES.STUFF])
      .json;

    const params = paramsHelper
      .loader()
      .setEndpointApi()
      .setObjectType(DOCUMENT_TYPES.GO)
      .setNavParams(0, 9999)
      .setSearchParams(search);

    this.collectionService.loadChunkCached(params)
      .subscribe(
        r => {
          this.resourcesList = r.documents;
        });
  }
  
  private updateDocument(document:IDocument){
    this.document = document;
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/game-event-map-page/game-event-map-page.component.ts